import Iconify from 'src/components/Iconify';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/@/components/ui/tabs';
import { Label } from 'src/@/components/ui/label';
import IdentificacaoSection from './realstate/IdentificacaoSection';
import PoliticasSection from './realstate/PoliticasSection';
import LocacaoVendaSection from './realstate/LocacaoVendaSection';
import FuncoesSection from './realstate/FuncoesSection';
import EscopoSection from './realstate/EscopoSection';
import PerguntasEssenciaisSection from './realstate/PerguntasEssenciaisSection';
import BuscaCatalogoSection from './realstate/BuscaCatalogoSection';
import EnvioCrmParceiroSection from './realstate/EnvioCrmParceiroSection';
import EnvioAtendimentoSection from './realstate/EnvioAtendimentoSection';
import CriacaoLeadFunilSection from './realstate/CriacaoLeadFunilSection';
import TomConversaSection from './realstate/TomConversaSection';
import TransferenciaSection from './realstate/TransferenciaSection';
import InstrucoesAdicionaisSection from './realstate/InstrucoesAdicionaisSection';

const SUB_TABS = [
    { value: 'identificacao', label: 'Identificação', icon: 'mdi:office-building-outline' },
    { value: 'politicas', label: 'Políticas', icon: 'mdi:file-document-outline' },
    { value: 'locacao-venda', label: 'Locação e Venda', icon: 'mdi:key-variant' },
    { value: 'funcoes', label: 'Funções', icon: 'mdi:cog-outline' },
    { value: 'escopo', label: 'Escopo de Atendimento', icon: 'mdi:filter-variant' },
    { value: 'busca-catalogo', label: 'Busca & Catálogo', icon: 'mdi:magnify' },
    { value: 'tom-conversa', label: 'Tom da Conversa', icon: 'mdi:chat-processing-outline' },
    { value: 'transferencia', label: 'Transferência', icon: 'mdi:account-arrow-right-outline' },
    { value: 'perguntas-essenciais', label: 'Perguntas Essenciais', icon: 'mdi:comment-question-outline' },
    { value: 'envio-crm-parceiro', label: 'Integração CRM', icon: 'mdi:database-export-outline' },
    { value: 'instrucoes-adicionais', label: 'Instruções Adicionais', icon: 'mdi:format-quote-close' },
];

export default function RealstateModuleConfig({ aiAgent, changeModuleConfig, changeTomConversa, changePersona }) {
    return (
        <Tabs defaultValue="identificacao" orientation="vertical" className="flex gap-6 items-start">
            <TabsList className="flex flex-col items-stretch h-auto w-[240px] bg-white rounded-xl border border-gray-100 p-2 gap-1 shrink-0">
                {SUB_TABS.map((tab) => (
                    <TabsTrigger
                        key={tab.value}
                        value={tab.value}
                        className="justify-start gap-2 px-3 py-2.5 rounded-lg text-sm text-gray-600 hover:bg-gray-50 data-[state=active]:bg-violet-50 data-[state=active]:text-[#7C3AED] data-[state=active]:shadow-none data-[state=active]:font-semibold w-full"
                    >
                        <Iconify icon={tab.icon} width={16} />
                        <span className="text-left flex-1 truncate">{tab.label}</span>
                    </TabsTrigger>
                ))}
            </TabsList>

            <div className="flex-1 min-w-0">
                <TabsContent value="identificacao" className="mt-0">
                    <IdentificacaoSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} changePersona={changePersona} />
                </TabsContent>
                <TabsContent value="politicas" className="mt-0">
                    <PoliticasSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="locacao-venda" className="mt-0">
                    <LocacaoVendaSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="funcoes" className="mt-0">
                    <FuncoesSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="escopo" className="mt-0">
                    <EscopoSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="busca-catalogo" className="mt-0">
                    <BuscaCatalogoSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="tom-conversa" className="mt-0">
                    <TomConversaSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} changeTomConversa={changeTomConversa} />
                </TabsContent>
                <TabsContent value="transferencia" className="mt-0">
                    <TransferenciaSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="perguntas-essenciais" className="mt-0">
                    <PerguntasEssenciaisSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="envio-crm-parceiro" className="mt-0">
                    <div className="flex flex-col gap-4">
                        <CriacaoLeadFunilSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                        <IntegracaoParceiroSwitcher aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                    </div>
                </TabsContent>
                <TabsContent value="instrucoes-adicionais" className="mt-0">
                    <InstrucoesAdicionaisSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
            </div>
        </Tabs>
    );
}

// Seletor das duas formas de integração com o CRM parceiro. São mutuamente
// exclusivas: o usuário escolhe Envio de Lead OU Envio de Atendimento, e apenas
// a seção correspondente é renderizada.
const MODOS_INTEGRACAO = [
    {
        value: 'lead',
        label: 'Envio de Lead',
        descricao: 'Cria um lead no CRM parceiro quando o cliente é qualificado.',
        icon: 'mdi:database-export-outline',
    },
    {
        value: 'atendimento',
        label: 'Envio de Atendimento',
        descricao: 'Abre um atendimento/oportunidade e guarda o código para uso futuro.',
        icon: 'mdi:account-tie-outline',
    },
];

function IntegracaoParceiroSwitcher({ aiAgent, changeModuleConfig }) {
    const funcoes = aiAgent?.config?.module?.realstate?.funcoes || {};
    const modo = funcoes.integracaoParceiroModo === 'atendimento' ? 'atendimento' : 'lead';

    const setModo = (value) => {
        if (value === modo) return;
        changeModuleConfig({
            funcoes: { ...funcoes, integracaoParceiroModo: value },
        });
    };

    return (
        <div className="flex flex-col gap-4">
            <div className="bg-white rounded-xl border border-gray-100 p-4">
                <Label className="text-xs font-semibold uppercase tracking-wider text-gray-500">
                    Forma de integração com o CRM parceiro
                </Label>
                <p className="text-xs text-gray-500 mt-1 mb-3">
                    Escolha uma das formas. As duas são mutuamente exclusivas.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {MODOS_INTEGRACAO.map((m) => {
                        const ativo = modo === m.value;
                        return (
                            <button
                                key={m.value}
                                type="button"
                                onClick={() => setModo(m.value)}
                                className={`flex items-start gap-3 rounded-xl border p-3 text-left transition-colors ${
                                    ativo ? 'border-[#7C3AED] bg-violet-50/50' : 'border-gray-200 hover:bg-gray-50'
                                }`}
                            >
                                <div className={`w-9 h-9 rounded-xl flex items-center justify-center shrink-0 ${
                                    ativo ? 'bg-[#7C3AED]' : 'bg-violet-50'
                                }`}>
                                    <Iconify icon={m.icon} width={18} className={ativo ? 'text-white' : 'text-violet-600'} />
                                </div>
                                <div className="flex flex-col">
                                    <span className="text-sm font-medium text-gray-900">{m.label}</span>
                                    <span className="text-xs text-gray-500">{m.descricao}</span>
                                </div>
                            </button>
                        );
                    })}
                </div>
            </div>

            {modo === 'lead' ? (
                <EnvioCrmParceiroSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
            ) : (
                <EnvioAtendimentoSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
            )}
        </div>
    );
}
